module.exports = __webpack_public_path__ + "img/bt.ae790b99.jpg";